import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Challengeimpact() {
  return (
    <section className="challenge_impact p-100 bg_blue">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>The Challenge</h2>
            <p>
              Developing such an advanced and objective-focused platform was the
              challenge here that Tekrevol had to overcome.
            </p>
            <p>
              From integrating relevant features that would help the web app
              extract quality data for an organization to designing an appealing
              interface that would attract the students into using it, the
              approach to developing the web app had to be strategic and
              innovative.
            </p>
            <p>
              Moreover, we knew that creating such a platform would not only
              maximize an educational organization's effectiveness or
              performance but also become the pinnacle of change in the
              education system. So, the stakes were high!
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="offset-xl-1 offset-lg-1 my-auto text-center"
          >
            <div className="challenge_impact">
              <StaticImage
                src="../../../images/case-studies/impact/challenge.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={912}
                height={499}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Challengeimpact;
